module.exports = __webpack_public_path__ + "static/img/zsbm.5bfd92a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsbm.jpg
// module id = RlV+
// module chunks = 2